import { Header } from "../components/header/Header";
import FooterOne from "../components/footer/FooterOne";
import PrivacyText from "../components/content/PrivacyText";

const Privacy = () => {
  return (
    <div>
      <div style={{ backgroundColor: "#0c0f19" }}>
        <Header />
      </div>
      <PrivacyText />
      <FooterOne />
    </div>
  );
};

export default Privacy;
